import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Navbar initialized — Bootstrap handles dropdowns via data attributes
  }
}
